/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialCouponResponse } from '../../models/editorial-coupon-response';

export interface GetEditorialCouponRequest$Params {
  id: number;
}

export function getEditorialCouponRequest(http: HttpClient, rootUrl: string, params: GetEditorialCouponRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCouponResponse>> {
  const rb = new RequestBuilder(rootUrl, getEditorialCouponRequest.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialCouponResponse>;
    })
  );
}

getEditorialCouponRequest.PATH = '/api/editorial/company-coupon-requests/{id}';
